module.exports = __webpack_public_path__ + "media/customizations/trilogy/back-df2badcbc12b346fff60322aba61e946.jpg";